<loren-page-content>
  @if(error()) {
  <p>{{ "error_page.general_error_message" | transloco }}</p>
  } @else {
      <mat-card-title class="loren-home-selected-assets-header">
          {{ "selected_assets.selected_assets" | transloco: {count: selectedAssetsIds().length} }}
          <button
                  matButton="filled"
                  #menuTrigger="matMenuTrigger"
                  [matMenuTriggerFor]="addAssets">
              <mat-icon>add_circle_outline</mat-icon>
              {{ "selected_assets.add_asset_to_selected" | transloco }}
          </button>
      </mat-card-title>
  @if(selectedAssetsIds().length) {
  <div class="loren-home-selected-assets-content">
    @for(id of selectedAssetsIds(); track id) {
    <loren-asset-card
      [assetId]="id"
      [canRemove]="true"
      (remove)="handleAssetRemove($event)"/>
    }
  </div>
  }@else {
  <mat-card class="loren-home-selected-assets-none">
    <div class="loren-home-selected-assets-none-icon">
      <mat-icon svgIcon="no_data"></mat-icon>
    </div>
    <p class="loren-home-selected-assets-none-text">
      <span>
        {{ "selected_assets.no_selected_assets" | transloco }}
        <button matButton="filled" [disabled]="true">
          <mat-icon>add_circle_outline</mat-icon>
          {{"selected_assets.add_asset_to_selected" | transloco }}</button
        >
      </span>
      <span>
        {{ "selected_assets.max_selected_assets" | transloco }}
      </span>
    </p>
  </mat-card>

  }
  <mat-menu #addAssets="matMenu">
    <ng-template matMenuContent>
      @if (!assets()?.length) {
      <div class="loren-home-selected-assets-menu-empty">
        <div class="loren-home-selected-assets-menu-empty-icon">
          <mat-icon svgIcon="no_data"></mat-icon>
        </div>
        <p class="loren-home-selected-assets-menu-empty-text">
          {{ "selected_assets.no_assets" | transloco }}
        </p>
      </div>
      <div class="loren-home-selected-assets-menu-create">
        <button matButton="filled" class="btn-green" (click)="handleDefineAsset()">
          {{ "selected_assets.create_asset" | transloco }}
        </button>
      </div>
      } @else {
      <loren-filters
        [placeholder]="'selected_assets.search_assets' | transloco"
        [withNumber]="6"
        [items]="getAssetsForFilter()"
        [initiallySelected]="getSelectedIds()"
        (selectionSubmitted)="
          saveCheckedAssets($event); menuTrigger.closeMenu()
        ">
      </loren-filters>
      }
    </ng-template> </mat-menu
  >}
</loren-page-content>
